module.exports = __webpack_public_path__ + "img/42b52ccabc20a689.gif";